"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var i18next_1 = __importDefault(require("i18next"));
var core_1 = require("@material-ui/core");
var actions_1 = __importDefault(require("../actions"));
var format_1 = __importDefault(require("../../app/util/format"));
var StatisticsGraphic_1 = __importDefault(require("./StatisticsGraphic"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c;
    return core_1.createStyles({
        grid: {
            marginTop: theme.spacing(5),
        },
        card: (_a = {
                display: 'flex',
                flexDirection: 'column',
                boxShadow: 'none',
                height: '100%',
                backgroundColor: 'transparent',
                alignItems: 'flex-start',
                maxWidth: '400px'
            },
            _a[theme.breakpoints.up('md')] = {
                alignItems: 'flex-start',
                flexDirection: 'row',
                width: '600px',
            },
            _a[theme.breakpoints.up('lg')] = {
                alignItems: 'flex-start',
                flexDirection: 'row',
                width: '350px',
            },
            _a),
        cardContent: (_b = {
                paddingTop: theme.spacing(0),
                paddingLeft: theme.spacing(0),
                paddingRight: theme.spacing(0),
                '&:last-child': {
                    paddingBottom: 0,
                }
            },
            _b[theme.breakpoints.up('md')] = {
                paddingTop: theme.spacing(0),
            },
            _b),
        statsLabel: {
            marginTop: theme.spacing(2),
        },
        getStartedButton: (_c = {
                paddingTop: theme.spacing(1),
                paddingBottom: theme.spacing(1),
                width: '100%'
            },
            _c[theme.breakpoints.up('sm')] = {
                width: '150px',
            },
            _c),
        stats: {
            flexGrow: 0.8,
            width: '384px',
            maxWidth: '800px',
        },
    });
});
var StatisticsSliver = function () {
    var classes = useStyles();
    var dispatch = react_redux_1.useDispatch();
    var loadStats = function () { return dispatch(actions_1.default.loadStats()); };
    var statistics = react_redux_1.useSelector(function (state) { return state.home.statistics; });
    var userCount = statistics.userCount, linkCount = statistics.linkCount, clickCount = statistics.clickCount;
    // ensure number will never be null
    var statisticsToShow = [
        {
            label: i18next_1.default.t('general.officerType').toUpperCase() + " ONBOARD",
            number: userCount,
        },
        { label: 'SHORT LINKS CREATED', number: linkCount },
        { label: 'CLICKS', number: clickCount },
    ];
    // Call once
    react_1.useEffect(function () {
        loadStats();
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Typography, { variant: "h3", color: "textPrimary" },
            "The official link shortener for ",
            i18next_1.default.t('general.linkAdmins')),
        react_1.default.createElement(core_1.Grid, { container: true, className: classes.grid, spacing: 2 },
            react_1.default.createElement(core_1.Grid, { container: true, item: true, spacing: 6, direction: "column", className: classes.stats },
                statisticsToShow.map(function (stat) { return (react_1.default.createElement(core_1.Grid, { item: true, key: stat.label },
                    react_1.default.createElement(core_1.Card, { className: classes.card },
                        react_1.default.createElement(core_1.CardContent, { className: classes.cardContent },
                            react_1.default.createElement(core_1.Typography, { color: "primary", variant: "h4" },
                                react_1.default.createElement("strong", null, format_1.default.format(stat.number))),
                            react_1.default.createElement(core_1.Typography, { className: classes.statsLabel, variant: "body2", color: "textPrimary" }, stat.label))))); }),
                react_1.default.createElement(core_1.Grid, { item: true },
                    react_1.default.createElement(core_1.Button, { className: classes.getStartedButton, href: "/#/login", size: "medium", color: "primary", variant: "contained" }, "Get started"))),
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(StatisticsGraphic_1.default, null)))));
};
exports.default = StatisticsSliver;
